import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse } from '@/types/api/api-v2';
import { NotificationSettings } from '@/types/notifications';

export default async function getNotificationSettings(): Promise<NotificationSettings> {
  try {
    const {
      data: { data: notificationSettings },
    } = await spiritoryWebApi.get<BaseApiResponse<NotificationSettings>>('/notifications/settings');
    return notificationSettings;
  } catch (err) {
    console.error(err);
    throw new Error('Failed to fetch notification settings');
  }
}
